export enum TrackingTypes {
  MATCHING = 0,
  SINGLE = 1,
  SINGLE_MATCHING = 2
}
